// Dynamically load i18n resources based on branch type (e.g., 'igov', 'ihos')
// Single source of truth: import.meta.env.VITE_BRANCH (fallback 'igov')
const branchType = (import.meta && import.meta.env && import.meta.env.VITE_BRANCH) || 'igov';

// Cache-busting version cho các file i18n (copy thô, không hash bởi rollup)
const I18N_VERSION = (import.meta && import.meta.env && import.meta.env.VITE_I18N_VERSION) || '1.0.0.0';

async function loadBranchMessages(branch) {
  const base = `./vi/branch/${branch}/`;
  const v = `?v=${I18N_VERSION}`;
  const [
    i18nMainMod,
    i18nValidateMod,
    i18nComponentMod,
    i18nEnumMod,
    i18nCommonMod,
    i18nBaseFormMod,
    i18nHelpLinkMod,
    i18nPagesMod,
    i18nGettingCommon,
    i18nNotificationPopup
  ] = await Promise.all([
    import(/* @vite-ignore */ `${base}i18nMain.js${v}`),
    import(/* @vite-ignore */ `${base}i18nValidate.js${v}`),
    import(/* @vite-ignore */ `${base}i18nComponent.js${v}`),
    import(/* @vite-ignore */ `${base}i18nEnum.js${v}`),
    import(/* @vite-ignore */ `${base}i18nCommon.js${v}`),
    import(/* @vite-ignore */ `${base}i18nBaseForm.js${v}`),
    import(/* @vite-ignore */ `${base}i18nHelpLink.js${v}`),
    import(/* @vite-ignore */ `${base}i18nPages.js${v}`),
    import(/* @vite-ignore */ `${base}i18nGettingCommon.js${v}`),
    import(/* @vite-ignore */ `${base}i18nNotificationPopup.js${v}`),
  ]);

  return {
    i18nMain: i18nMainMod.default,
    i18nValidate: i18nValidateMod.default,
    i18nComponent: i18nComponentMod.default,
    i18nEnum: i18nEnumMod.default,
    i18nCommon: i18nCommonMod.default,
    i18nBaseForm: i18nBaseFormMod.default,
    i18nHelpLink: i18nHelpLinkMod.default,
    i18nPages: i18nPagesMod.default,
    i18nGettingCommon: i18nGettingCommon.default,
    i18nNotificationPopup: i18nNotificationPopup.default,
  };
}

let viMessages;
try {
  viMessages = await loadBranchMessages(branchType);
} catch (error) {
  // Fallback to 'igov' if the specified branch isn't available
  if (branchType !== 'igov') {
    console.warn(`[i18n] Failed to load branch "${branchType}". Falling back to 'igov'.`, error);
    viMessages = await loadBranchMessages('igov');
  } else {
    throw error;
  }
}

export default {
  vi: viMessages,
};
